module.exports = __webpack_public_path__ + "static/media/welding.ffff7f0f.png";